<template>
  <div>
    <p class="P1">This app respects and protects the privacy of all users who use the service. In order to provide you
        with more accurate and personalized services, this app will use and disclose your personal information in
        accordance with this Privacy Policy. However, this application will treat this information with a high degree of
        diligence and prudence. Except as otherwise provided in this Privacy Policy, this application will not disclose
        or provide this information to third parties without your prior permission. This app will up<a
            id="_GoBack" />date this privacy policy from time to time. By agreeing to this Application Services Use
        Agreement, you are deemed to have agreed to the entire content of this Privacy Policy. This Privacy Policy is an
        integral part of this Application Service Agreement.</p>
    <p class="Standard"> </p>
    <p class="Standard">1. Scope of application</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) the personal registration information you provide in accordance with the requirements of
        this application when you register for this application account;</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) The information on your browser and computer that the application automatically receives and
        records when you use the App Network Service or access the App Platform webpage, including but not limited to
        your IP address, browser type, Data such as language used, date and time of access, hardware and software
        feature information, and web page records you need;</p>
    <p class="Standard"> </p>
    <p class="Standard">(c) User personal data obtained by the application from a business partner through legal means.
    </p>
    <p class="Standard"> </p>
    <p class="Standard">You understand and agree that the following information does not apply to this Privacy Policy:
    </p>
    <p class="Standard"> </p>
    <p class="Standard">(a) the keyword information you entered when using the search service provided by the app;</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) Relevant information collected by you in this application, including but not limited to
        participation activities, transaction information and evaluation details;</p>
    <p class="Standard"> </p>
    <p class="Standard">(c) Violation of the law or violation of this Code of Conduct and the actions that this
        application has taken against you.</p>
    <p class="Standard"> </p>
    <p class="Standard">2. Information use</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) This application does not provide, sell, rent, share or trade your personal information to
        any unrelated third party, unless you have obtained your permission in advance, or the third party and the
        application (including the application affiliate) are separate or common. To provide you with services, and
        after the service is over, it will be banned from accessing all of this material that it has previously been
        able to access.</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) This application also does not permit any third party to collect, edit, sell or distribute
        your personal information by any means. Any user of this application platform who engages in the above
        activities, once found, the application has the right to immediately terminate the service agreement with the
        user.</p>
    <p class="Standard"> </p>
    <p class="Standard">(c) For the purpose of serving the User, the App may use the information you use to provide you
        with information of interest to you, including but not limited to, sending you product and service information,
        or sharing information with the App Partner so that they may Send you information about its products and
        services (the latter requires your prior consent).</p>
    <p class="Standard" />
    <p class="Standard">3. Information disclosure</p>
    <p class="Standard"> </p>
    <p class="Standard">In the following circumstances, this application will disclose your personal information in
        whole or in part according to your personal wishes or the law:</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) disclose to third parties with your prior consent;</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) To provide the products and services you request, you must share your personal information
        with third parties;</p>
    <p class="Standard"> </p>
    <p class="Standard">(c) Disclosure to third parties or administrative or judicial authorities in accordance with the
        relevant provisions of the law, or at the request of the administrative or judicial authorities;</p>
    <p class="Standard"> </p>
    <p class="Standard">(d) If you have violated relevant Chinese laws, regulations or this application service
        agreement or related rules, you need to disclose it to third parties;</p>
    <p class="Standard"> </p>
    <p class="Standard">(e) If you are a qualified IP Complainant and have filed a complaint, it should be disclosed to
        the Respondent at the request of the Complainant so that both parties can handle possible rights disputes;</p>
    <p class="Standard"> </p>
    <p class="Standard">(f) In a transaction created on this application platform, if any party to the transaction
        performs or partially fulfills the transaction obligation and requests for information disclosure, the
        application has the right to decide to provide the user with the contact information of the counterparty, etc.
        Information to facilitate the completion of a transaction or the resolution of a dispute.</p>
    <p class="Standard"> </p>
    <p class="Standard">(g) Other disclosures that this application considers appropriate in accordance with laws,
        regulations or website policies.</p>
    <p class="Standard"> </p>
    <p class="Standard">4. Information storage and exchange</p>
    <p class="Standard"> </p>
    <p class="Standard">The information and materials collected by you in this application will be stored on the
        application and/or the servers of its affiliates, which may be transmitted to your country, region or the
        location where the application collects information and materials. It is accessed, stored and displayed outside
        the country.</p>
    <p class="Standard"> </p>
    <p class="Standard">5. Use of cookies</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) In the event that you do not refuse to accept cookies, the App will set or access cookies on
        your computer so that you can log in or use cookies-based services or features that rely on cookies. This app
        uses cookies to provide you with more thoughtful and personalized services, including promotional services.</p>
    <p class="Standard" />
    <p class="Standard">(b) You have the right to accept or reject the acceptance of cookies. You can refuse to accept
        cookies by modifying your browser settings. However, if you choose to refuse to accept cookies, you may not be
        able to log in or use this application web service or feature that relies on cookies.</p>
    <p class="Standard"> </p>
    <p class="Standard">(c) This policy will apply to information obtained through the cookies provided in this
        application.</p>
    <p class="Standard"> </p>
    <p class="Standard">6. Information security</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) This application account has security protection. Please keep your username and password
        information safe. This application will ensure that your information is not lost, not abused or altered, by
        security measures such as encrypting user passwords. Despite the aforementioned security measures, please also
        note that there are no “perfect security measures” on the information network.</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) When using this application web service for online transactions, you will inevitably have to
        deal with the counterparty or potential transaction pair</p>
    <p class="Standard"> </p>
    <p class="Standard">7. Changes to this Privacy Policy</p>
    <p class="Standard"> </p>
    <p class="Standard">(a) If we decide to change our Privacy Policy, we will post those changes in this Policy, on our
        website, and in such locations as we deem appropriate, so that you can understand how we collect and use your
        personal information and who can access it. And under what circumstances we will disclose this information.</p>
    <p class="Standard"> </p>
    <p class="Standard">(b) The company reserves the right to modify this policy at any time, so please check it
        frequently. In the event of a material change to this policy, the Company will notify you by notice on the
        website.</p>
    <p class="Standard"> </p>
    <p class="Standard">The party discloses its personal information, such as contact information or postal address.
        Please protect your personal information and provide it to others only when necessary. If you find that your
        personal information is leaked, especially if the application username and password are leaked, please contact
        this application customer service immediately so that the application can take corresponding measures.</p>
    <p class="Standard"> </p>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  mounted() {},
};
</script>

<style type="text/css">
@page {
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
}

td,
th {
  vertical-align: top;
  font-size: 12pt;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  clear: both;
}

ol,
ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* "li span.odfLiEnd" - IE 7 issue*/
li span {
  clear: both;
  line-height: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

span.footnodeNumber {
  padding-right: 1em;
}

span.annotation_style_by_filter {
  font-size: 95%;
  font-family: Arial;
  background-color: #fff000;
  margin: 0;
  border: 0;
  padding: 0;
}

span.heading_numbering {
  margin-right: 0.8rem;
}

* {
  margin: 0;
}

.P1 {
  font-size: 24pt;
  font-weight: bold;
  margin-bottom: 0.1945in;
  margin-top: 0in;
  text-align: left !important;
  font-family: 宋体;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0in;
  margin-right: 0in;
  text-indent: 0in;
  padding: 0in;
  border-style: none;
}

.P2 {
  font-size: 13.5pt;
  font-weight: bold;
  margin-bottom: 0.1945in;
  margin-top: 0.1945in;
  text-align: left !important;
  font-family: 宋体;
  writing-mode: horizontal-tb;
  direction: ltr;
  margin-left: 0in;
  margin-right: 0in;
  text-indent: 0in;
  padding: 0in;
  border-style: none;
}

.P3 {
  font-size: 12pt;
  margin-bottom: 0in;
  margin-left: 0in;
  margin-right: 0in;
  margin-top: 0in;
  text-align: left !important;
  text-indent: 0in;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
  padding: 0in;
  border-style: none;
}

.Standard {
  font-size: 10.5pt;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
  text-align: justify !important;
}

.Internet_20_link {
  color: #0000ff;
  text-decoration: underline;
}

.T1 {
  color: #999999;
  font-family: Helvetica Neue Light;
  letter-spacing: normal;
  font-style: normal;
}

.T2 {
  color: #666666;
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0043in;
  font-style: normal;
}

.T3 {
  color: #666666;
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0043in;
  font-style: normal;
}

.T4 {
  color: #666666;
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0043in;
  font-style: normal;
}

.T5 {
  color: #333333;
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0047in;
  font-style: normal;
  font-weight: bold;
}

.T6 {
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0043in;
  font-style: normal;
}

.T7 {
  font-family: Helvetica Neue Light;
  letter-spacing: -0.0043in;
  font-style: normal;
}
</style>